package com.example.readingnotes.domain.usecase

import com.example.readingnotes.domain.model.*
import com.example.readingnotes.domain.repository.StripeConnectRepository
import com.example.readingnotes.util.Result

/**
 * Get Stripe Connect onboarding link
 */
class GetStripeConnectOnboardingLinkUseCase(
    private val repository: StripeConnectRepository,
) {
    suspend operator fun invoke(
        redirectUrl: String,
        refreshUrl: String?,
    ): Result<OnboardingLink> =
        repository.getOnboardingLink(redirectUrl, refreshUrl)
}

/**
 * Get Stripe Connect account status
 */
class GetStripeConnectStatusUseCase(
    private val repository: StripeConnectRepository,
) {
    suspend operator fun invoke(): Result<StripeConnectStatus> = repository.getAccountStatus()
}

/**
 * Handle Stripe Connect OAuth callback
 */
class HandleStripeConnectCallbackUseCase(
    private val repository: StripeConnectRepository,
) {
    suspend operator fun invoke(code: String): Result<StripeConnectCallbackResult> =
        repository.handleCallback(code)
}

/**
 * Refresh Stripe Connect account status
 */
class RefreshStripeConnectStatusUseCase(
    private val repository: StripeConnectRepository,
) {
    suspend operator fun invoke(): Result<StripeConnectStatus> = repository.refreshAccountStatus()
}
